/**
 * created by lei lei
 *稿件编辑器
 */
import React from 'react';
import {Scrollbars} from 'react-custom-scrollbars';
import {Button, Icon, Modal, message} from 'antd'
import $ from 'jquery'
import BaseComponent from "../../base/BaseComponent"
import EditorMenu from "./components/EditorMenu"
import StaticButtonArea from "./staticButton/staticButtonArea";
import PictureAmend from "./components/toolbarAmendModal/pictureAmend";
import {uuid} from "../../utils";
import VideoAmend from "./components/toolbarAmendModal/videoAmend";
import HyperlinkTool from "./toolsSpace/tools/hyperlinkTool/hyperlinkTool";
import {DetailDialog} from "../resource/view/dialog/video/video";
import {systemBaseEvent} from "../../base/baseEvent";

// const HeartIcon = props => <Icon component={HeartSvg} {...props} />;
const topBtnHeight = 64;//顶部按钮高度
const publishSetWidth = 272;//发布设置宽度
const publishSetHeight = 850;//发布设置高度
const editorSetHeight = 70;//编辑器设置的宽
const upAndDownSpacing = 15;//编辑器基本信息和内容之间空白高度
const informationDownHeight = 424;//基本信息高度
const informationUpnHeight = 72;//基本信息高度
const informationWidth = 880;//基本信息宽度
const editContentHeight = 490;//编辑器内容最小高度
const editContentWidth = 880;//编辑器内容宽度
const securityWidth = 200;//安全信息宽度
const securityHeight = 800;//安全信息高度
const tqs = "-tqs";//安全信息高度

const removeLabel = (content)=>{
    return content.replace(/<[^>]*>/g, "");
};

export default class Editor extends BaseComponent {
    static defaultProps = {
        publishSettingStatus: true,//右侧发布设置是否展开false 收起
        editorShow: true,//编辑器输入区显示
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            securityStatus: false,//左侧安全检测是否展开false 收起
            publishSettingStatus: this.props.publishSettingStatus,
            informationStatus: props.informationStatus,//基本信息展开收起false 收起
            content: '<p></p>',//编辑器内容
            titleStatus: false,//标题的展开收起，false 收起
            title: '',//标题
            contentText: '',//编辑器的纯文字
            dynamicParams: props.dynamicParams,//动态参数，调用此组件可将此参数给各个插件
            pictureAmendKey: uuid(),
            isShowLockModal: false,
            LockedData:{},
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        console.log(window.themeBgColor)
        let onunload = this.sysConfigGetValueByKey("Editor.onunload.intercept", "");
        if(onunload) {
            // 这个功能会同时阻断页面刷新，暂不使用
            // window.onbeforeunload =this.onclose;
        }
        let that = this;
        this.initEditor(() => {
            setTimeout(()=>{//这里如果不这样会偶发导致编辑器没渲染完执行了外部回调报错
                that.onEditorLoadOver()
            },0);
        });
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        this.setState({})
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    onclose = (event) =>{
        // var e = window.event ||e;
        event.returnValue="确认关闭页面吗？";
        // if(event.clientX>document.body.clientWidth&&event.clientY<0||event.altKey){
        //     return "您要离开吗？";
        // }
    };

    //初始化编辑器
    initEditor(callback) {
        //不允许动，必须这么写。解决react 调用原生js,编辑器加载问题
        try {
            window.ueditor.delEditor("webbereditor")
        } catch (e) {
            //自定义编辑器
            window.ueditor.editorRenderSuccess = () => {
                console.log('editorRenderSuccess', '编辑器渲染完成');
                callback();
                // 图片修改弹窗
                window.ueditor.ui._dialogs.insertimageDialog = {
                    open: ()=>this.pictureAmend.open(window.ueditor.selection.getRange().getClosedNode())
                }
                //视频修改弹窗
                window.ueditor.ui._dialogs.insertvideoDialog = {
                    open: ()=>this.VideoAmend.open(window.ueditor.selection.getRange().getClosedNode())
                }

                //视频预览弹窗
                window.ueditor.ui._dialogs.detailDialog = {
                    open: ()=>this.detailDialog.open(window.ueditor.selection.getRange().getClosedNode())
                }
                //链接修改弹窗
                window.ueditor.ui._dialogs.linkDialog = {
                    open: ()=>this.hyperlinkTool.click()
                }
                // 重新定义编辑器插入html片段方法
                window.ueditor.rmtExecCommand = function (code,val) {
                    if(code === "inserthtml") {
                        let source = window.ueditor.queryCommandState('source');
                        if(source === 1) {
                            message.destroy();
                            message.warning("源码模式下不支持该操作");
                            return false
                        }
                        window.ueditor.execCommand(code,val);
                        return true
                    }
                }
            };
            window.ueditor.render("webbereditor");
            window.getTitlePageHTML = function () {
            };
            window.ueditor.reactScrollbarScroll = function(e){
                //外层react编辑器滚动条滚动时触发
                console.log("---------外层react编辑器滚动条滚动--------")
            };
            //编辑器内容改变
            window.ueditor.addListener('contentchange', () => {
                let content = this.getEditContent();
                console.log('--------编辑器内容改变回调------',content);
                systemBaseEvent.syncPlaybackExec("editorContentChange", content)
                setTimeout(()=>{
                    console.log('--------编辑器内容改变回调------',this.getEditContent());
                    this.editorMenu.listenContentChange();
                });
                $('#hideEditorContent').html(content);
                this.setState({
                    contentText: content
                });
                // $("#contentAllCountAfterRemoveLabel").html(removeLabel(content).length);
                // $("#contentAllCountAfterRemoveLabel").html(window.ueditor.getContentTxt().length);
                this.onEditorContentChange(content);

            });
            //监听编辑器点击
            window.ueditor.addListener('click', () => {
                this.editorMenu.listenContentClick();
                console.log('编辑器点击变化监听')
            });

            window.ueditor.addListener('keydown', (type, e)=>{
                let keyCode = e.keyCode || e.which;
                if(keyCode === 88 && e.ctrlKey){
                    setTimeout(()=>{
                        window.ueditor.fireEvent('contentchange');
                    });
                }
            });
        }
    }

    // 编辑器初始化完毕的回调
    onEditorLoadOver() {
        if(this.props && typeof this.props.onEditorLoadOver == 'function') {
            return this.props.onEditorLoadOver()
        }
    }

    // 编辑器内容改变的回调
    onEditorContentChange(content) {
        if(this.props && typeof this.props.onEditorContentChange == 'function') {
            return this.props.onEditorContentChange(content)
        }
    }

    render() {
        //false 都是收起，true展开
        let currentPublishWidth = this.state.publishSettingStatus ? publishSetWidth : 0;//发布设置是否收起收起为0
        let currentSecurityWidth = this.state.securityStatus ? securityWidth : 0;//安全检测信息，收起为0
        let currentInformationHeight = this.props.informationStatus ? informationDownHeight : informationUpnHeight;//基本信息展开收起高度
        return (
            <div >
                {/*遮罩层*/}
                {this.renderLockModal()}
                {/*编辑器图片修改弹窗*/}
                <PictureAmend key={this.state.pictureAmendKey} ref={ref=>this.pictureAmend=ref} onClose={()=>{this.setState({pictureAmendKey:uuid()})}} title={"修改图片"}/>
                {/*编辑器视频修改弹窗*/}
                <VideoAmend key={this.state.VideoAmendKey} ref={ref=>this.VideoAmend=ref} onClose={()=>{this.setState({VideoAmendKey:uuid()})}} title={"修改视频"}/>
                {/*视频预览*/}
                <DetailDialog ref={detailDialog=>this.detailDialog=detailDialog}/>
                {/*编辑器链接修改弹窗*/}
                <div style={{display:'none'}}>
                    <HyperlinkTool ref={ref=>this.hyperlinkTool=ref} hideHyperToolContent={this.props.hideHyperToolContent}/>
                </div>
                {/* 渲染顶部按钮*/}
                {this.renderTopBtnList()}
                <div style={{display: 'flex'}}>
                    <div style={{
                        width: document.body.clientWidth - currentPublishWidth,
                        background: 'rgba(235, 241, 249, 0.39)'
                    }}>
                        
                        <style>{`
                            ::-webkit-scrollbar {
                                width:5px;
                            }
                            ::-webkit-scrollbar-track {
                                border-radius:5px;
                            }
                            ::-webkit-scrollbar-thumb {
                                border-radius:10px;
                                background: #bbc0c7;
                            }
                            ::-webkit-scrollbar-thumb:window-inactive {
                                background: #bbc0c7;
                            }
                            ::-webkit-scrollbar-button{
                                display:none;
                                background:rgba(0,0,0,0.0);
                            }
                        `}</style>
                        
                        <div className={'editSetting'} style={{
                            height: editorSetHeight,
                            background: ' rgba(245, 248, 252, 0.39)'//'blue'
                        }}>
                            {/* 渲染编辑器设置*/}
                            {this.renderEditSetting()}
                        </div>
                        <div style={{height: document.body.clientHeight - topBtnHeight - editorSetHeight,background:'#EBF1F9'}}>
                            <Scrollbars
                                ref={scrollbars=>window.ueditor.reactScrollbar = scrollbars}
                                onScroll={(e)=>{
                                    window.ueditor.reactScrollbarScroll && window.ueditor.reactScrollbarScroll(e);
                                }}
                            >
                                <div style={{display: 'flex',paddingBottom: 14}}>
                                    {/* 中间基础信息*/}
                                    <div
                                        style={{width: document.body.clientWidth - currentPublishWidth - currentSecurityWidth}}>
                                        <div style={{height: upAndDownSpacing}}></div>
                                        {/*渲染基本信息*/}
                                        <div style={{
                                            maxHeight: currentInformationHeight,
                                            width: informationWidth,
                                            margin: '0 auto',
                                            borderRadius: 10,
                                            background: '#ffffff',
                                            position: 'relative',

                                        }}>
                                            <div style={{
                                                width: 32,
                                                height: 32,
                                                background: '#ffffff',
                                                opacity: 1,
                                                borderRadius: 20,
                                                position: 'absolute',
                                                bottom: '0px',
                                                right: '-42px',
                                                textAlign: 'center',
                                                lineHeight: '32px'
                                            }} onClick={() => {
                                                this.informationStatusChange()
                                            }}>
                                                {/*基本信息展开收缩按钮*/}
                                                {this.props.informationStatus ?
                                                    <Icon style={{color: 'rgba(0, 0, 0, 0.65)'}} type="up"/> :
                                                    <Icon style={{color: 'rgba(0, 0, 0, 0.65)'}} type="down"/>}
                                            </div>
                                                {this.renderInformation()}
                                        </div>
                                        <div style={{height: upAndDownSpacing}}></div>
                                        {/*渲染编辑器内容*/}
                                        <div className={'editContent'} style={{
                                            display: this.props.editorShow?'block':'none',
                                            minHeight: document.body.clientHeight - topBtnHeight - editorSetHeight - upAndDownSpacing * 2 - currentInformationHeight - 18,
                                            width: editContentWidth,
                                            margin: '0 auto',
                                            borderRadius: 10,
                                            background: '#ffffff',
                                        }}>
                                            <div id={'webbereditor'}></div>
                                            <div id={'hideEditorContent'} style={{display: 'none'}}></div>
                                        </div>
                                    </div>
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                    {/*渲染右侧模块*/}
                    {
                        this.props.editorRightModule ? (
                            this.renderRightModule()
                        ) : null
                    }
                </div>

            </div>
        )
    }

    //渲染顶部操作按钮
    renderTopBtnList() {
        if(this.props.editorActBtn){
            return <table cellPadding={0} height={64} cellSpacing={0} width={"100%"}><tbody><tr>
                <td>{this.props.editorActBtn}</td>
                <td style={{background:this.themeBgColor, maxWidth:300, paddingRight:50}} align={"right"}>
                    <StaticButtonArea dynamicParams={this.props.dynamicParams} />
                </td>
            </tr></tbody></table>
        }
    }

    //加锁弹窗
    renderLockModal() {
        let {LockedData}=this.state;
        return (
            this.state.isShowLockModal ? <>
                <Modal
                    title={'提醒'}
                    visible={this.state.isShowLockModal}
                    maskClosable={true}
                    onCancel={() => {
                        this.setState({
                            isShowLockModal: false,
                        })
                    }}
                    footer={[
                        <Button key={0} onClick={() => {
                            window.close();
                            setTimeout(()=>{
                                message.destroy();
                                message.error("关闭失败，您可以手动关闭此选项卡！");
                            },100);
                        }}>退出编辑</Button>,
                        <Button key={1} type={'primary'} onClick={() => {
                            this.setState({
                                isShowLockModal: false,
                            })
                        }}>继续预览</Button>,
                    ]}
                    width={400}
                >
                    <Icon type="info-circle"
                          style={{color: 'rgb(250, 173, 20)'}}/>&nbsp;
                    当前稿件“{LockedData && LockedData.LockUserName ? LockedData.LockUserName : ''}”正在编辑，您暂时无法操作，“{LockedData && LockedData.LockUserName ? LockedData.LockUserName : ''}”退出编辑5s后您可以刷新再试！
                </Modal>
            </> : null
        )
    }

    //是否展示遮罩
    showLockMask(LockedData) {
        this.setState({
            isShowLockModal: true,
            LockedData: LockedData,
        })
    }

    //数据回显
    showData = (data)=>{
        this.editorMenu.showData(data);
    };

    //渲染编辑器设置
    renderEditSetting() {
        return (
            <div>
                <EditorMenu pluginsSpaceConfig={this.props.pluginsSpaceConfig} ref={editorMenu=>this.editorMenu=editorMenu} dynamicParams={this.props.dynamicParams}/>
            </div>
        )
    }

    // 渲染基本信息
    renderInformation() {
        if(this.props.editorInformation){
            return this.props.editorInformation
        }
    }
    // 渲染右侧模块
    renderRightModule() {
        let currentPublishWidth = this.state.publishSettingStatus ? publishSetWidth : 0;//发布设置是否收起收起为0
        return (
            <div style={{position: 'relative'}}>
                {/*收起按钮*/}
                <div style={{
                    width: 80,
                    height: 65,
                    background: '#fbfcfe',
                    opacity: 1,
                    borderRadius: 20,
                    position: 'absolute',
                    bottom: (document.body.clientHeight - topBtnHeight) / 2,
                    left: '-16px',
                    lineHeight: '65px'
                }} onClick={() => {
                    this.setState({publishSettingStatus: !this.state.publishSettingStatus})
                }}>
                    {/*发布设置展开收缩按钮*/}
                    {this.state.publishSettingStatus ? <Icon style={{color: '#0050b3'}} type="right"/> :
                        <Icon style={{color: '#0050b3'}} type="left"/>}
                </div>
                {/*内容*/}
                <div style={{
                    width: currentPublishWidth,
                    height: document.body.clientHeight - topBtnHeight,
                    background: 'rgba(255, 255, 255, 0.39)',
                    display: this.state.publishSettingStatus ? '' : 'none',
                    boxShadow: '0px 3px 6px rgba(0, 80, 179, 0.16)'
                }}>
                    {/*渲染右侧模块*/}
                    <div style={{background: 'rgba(245, 248, 252, 0.39)',width: currentPublishWidth, height: document.body.clientHeight - topBtnHeight,fontFamily: 'Microsoft YaHei'}}>
                        <Scrollbars>
                            {this.props.editorRightModule}
                        </Scrollbars>
                    </div>
                </div>
            </div>
        )
    };

    //改变基本信息展开状态
    informationStatusChange(){
         this.props.onInformationStatusCallBack&&this.props.onInformationStatusCallBack(!this.props.informationStatus)
    }

    //获取编辑器内容
    getEditContent() {
        return window.ueditor.getContent();
    }

    //设置编辑器内容
    setContent(content) {
        if (content) {
            window.ueditor.setContent(content)
        }
    }

    //获取编辑器文字
    getContentText() {
        let oDiv = document.createElement('div');
        oDiv.innerHTML = window.ueditor.getContent();
        //去除样式
        $(oDiv).find('style').text('');
        //去除里面的空格以及转义字符
        let contentText = oDiv.innerText.replace(/<[^>]*>/g, "").replace(/&[a-z]*;/g, "").replace(/\s/g, "").replace(/(.{240}).*/, "$1...");
        console.log('编辑器文字', contentText);
        return contentText
    }
}